import React, { memo, useCallback } from "react";
import { DateRangePicker } from "@racoon/ui";
import { Search } from "lucide-react";
import { useT, Namespace } from "@racoon/i18n";

/**
 * Formats an ISO date string without milliseconds.
 * Converts "2026-01-09T14:17:13.000Z" to "2026-01-09T14:17:13Z"
 */
const formatISOWithoutMillis = (date: Date): string => {
  return date.toISOString().replace(/\.\d{3}Z$/, "Z");
};

interface VehicleFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  startDate: Date;
  endDate: Date;
  setDateRange: (start: string, end: string) => void;
}

const VehicleFiltersComponent: React.FC<VehicleFiltersProps> = ({
  searchQuery,
  onSearchChange,
  startDate,
  endDate,
  setDateRange,
}) => {
  const t = useT();

  const handleDateUpdate = useCallback(
    (values: any) => {
      const from = values?.range?.from;
      const to = values?.range?.to;
      if (from && to) {
        setDateRange(formatISOWithoutMillis(from), formatISOWithoutMillis(to));
      }
    },
    [setDateRange],
  );

  return (
    <div className="p-4 border-b space-y-3">
      <div className="flex items-center gap-2">
        <DateRangePicker
          enableTime
          initialDateFrom={startDate}
          initialDateTo={endDate}
          onUpdate={handleDateUpdate}
          className="!w-full"
          maxRangeDays={2}
          disableFutureDates={true}
          showPresets={false}
        />
      </div>

      <div className="relative">
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={t(Namespace.GpsTracking, "searchPlaceholder")}
          className="w-full text-sm px-3 h-8 pl-10 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 " />
      </div>
    </div>
  );
};

export const VehicleFilters = memo(VehicleFiltersComponent);
